import { createSlice } from '@reduxjs/toolkit'

export const loginSlice = createSlice({
  name: 'isLogged',
  initialState: {
    value: false,
  },
  reducers: {
    loggedin: (state) => {
      state.value = true
    },
    loggedoutt: (state) => {
      state.value = false
    },
  },
})

export const { loggedin, loggedoutt } = loginSlice.actions

export default loginSlice.reducer